/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";
import { isFlexServiceProduct } from "@/src/services/advocardService.tsx";

type PersonalDataProps = {
  formData: AbstractCase | Record<string, any>;
  product: AbstractCase;
};

const PersonalData = ({ formData, product }: PersonalDataProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Persönliche Angaben</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"gender"} sx={summaryStyle.scrollToAnchor} />
        Anrede
      </Grid>
      <Grid size={12}>
        {formData.client.gender === "male" ? "Herr" : "Frau"}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"givenName"} sx={summaryStyle.scrollToAnchor} />
        Vorname
      </Grid>
      <Grid size={12}>
        {formData.client.givenName}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"familyName"} sx={summaryStyle.scrollToAnchor} />
        Nachname
      </Grid>
      <Grid size={12}>
        {formData.client.familyName}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"telephone"} sx={summaryStyle.scrollToAnchor} />
        Telefonnummer
      </Grid>
      <Grid size={12}>
        {formData.customer.telephone}
      </Grid>
      {!isFlexServiceProduct(product) && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"insurancePolicyNumber"} sx={summaryStyle.scrollToAnchor} />
            Versichertennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.insurancePolicyNumber}
          </Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"caseReferenceNumber"} sx={summaryStyle.scrollToAnchor} />
            Schadennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.caseReferenceNumber}
          </Grid>
        </>
      )}
    </>
  );
};

export default PersonalData;
